import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/app.reducer';
import { selectSelectableProjects } from 'src/app/state/app.selectors';

@Component({
    selector: 'app-copy-classification-to-project-dialog',
    templateUrl: './copy-to-project-dialog.component.html',
    styleUrls: ['./copy-to-project-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CopyClassificationsToProjectDialogComponent {
  selectableProjects=this.store.select(selectSelectableProjects);
  selectedProjectId:number=0;
  constructor(private dialogRef: MatDialogRef<CopyClassificationsToProjectDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: {fromProject:number}, private store: Store<AppState> ) { }


}
